import { BOOK_CREW_STATUS_TYPES } from '@iso/enums';

export const OrderBy = {
  ASC: 'asc',
  DESC: 'desc'
};

export const sortOptionList = [
  {
    label: 'Recently added',
    value: 'ra',
    field: 'createdDate',
    order: OrderBy.DESC
  },
  {
    label: 'A-Z - Full Name',
    value: 'a-z-name',
    field: 'name',
    order: OrderBy.ASC
  },
  {
    label: 'Z-A - Email',
    value: 'z-a-email',
    field: 'name',
    order: OrderBy.DESC
  },
  {
    label: 'A-Z - Email',
    value: 'a-z-email',
    field: 'email',
    order: OrderBy.ASC
  },
  {
    label: 'Z-A - Full Name',
    value: 'z-a-name',
    field: 'email',
    order: OrderBy.DESC
  }
];

export const sortOptionListForContacts = [
  {
    label: 'A-Z - Email',
    value: 'a-z-email',
    field: 'email',
    order: OrderBy.ASC
  },
  {
    label: 'Z-A - Full Name',
    value: 'z-a-fullName',
    field: 'fullName',
    order: OrderBy.ASC
  }
];

export const amountDecimal = 2;

export const JobDocumentTypes = {
  W9: 'W9',
  INVOICES: 'Invoices',
  PROOF_OF_PAYMENT: 'Proof of Payments'
};

export const PAYMENT_DOCUMENT_TYPES = {
  INVOICE: 'invoice',
  PROOF_OF_PAYMENT: 'proof_of_payment'
};

export const sortIconHeightWidth = 16;

export const bookCrewStatusList = [
  {
    id: 1,
    status: BOOK_CREW_STATUS_TYPES.CONFIRMED,
    color: 'var(--ruthless-empress)'
  },
  {
    id: 2,
    status: BOOK_CREW_STATUS_TYPES.DECLINED,
    color: 'var(--flushed)'
  },
  {
    id: 3,
    status: BOOK_CREW_STATUS_TYPES.MEMO_SENT,
    color: 'var(--blue-party-parrot)'
  },
  {
    id: 4,
    status: BOOK_CREW_STATUS_TYPES.MEMO_SAVED,
    color: 'var(--cobalite)'
  },
  {
    id: 5,
    status: '',
    color: 'var(--simply-peachy)'
  }
];
